export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/visual-cues-icon.svg?1c7fb255cef059f066abd7eaef800c6b";